import "./AgileHeaderComponent.scss";

import { Flex, Text } from "@fluentui/react-northstar";
import React from "react";

interface AgileHeaderComponentProps {
  title: string;
  detailsBarText: string;
}

export const AgileHeaderComponent: React.FC<AgileHeaderComponentProps> = ({
  title,
  detailsBarText,
}) => {
  return (
    <div className="surveyHeader">
      <Flex space="between">
        <Text className="surveyHeader__title" content={title} size="large" weight="bold" />
      </Flex>
      <Text className="surveyHeader__details" size="small" content={detailsBarText} />
    </div>
  );
};
